import { render, staticRenderFns } from "./MyTeamField.vue?vue&type=template&id=e575abf8"
import script from "./MyTeamField.vue?vue&type=script&lang=js"
export * from "./MyTeamField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports